import { literal, string, struct } from 'io-ts/Decoder';

/**
 * Sent when an entire frame is deleted.
 */
export const FrameDeleted = struct({
	type: literal('frame-deleted'),
	frameId: string,
});
